module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedi2t"
  }, [_vm._v("“For I have sworn thee fair, and thought thee bright,")]), _vm._v(" "), _c('p', {
    staticClass: "dedi2"
  }, [_vm._v("Who art as black as hell, as dark as night.”")]), _vm._v(" "), _c('p', {
    staticClass: "dedi3"
  }, [_vm._v("—William Shakespeare,")]), _vm._v(" "), _c('p', {
    staticClass: "dedi2"
  }, [_vm._v("Sonnet CXLVII")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c36e402","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Dedication3.vue
// module id = 78
// module chunks = 0